<template>
    
    <b-container class="p-0">
        <b-row class="my-2 mx-0">
            <b-col>
                <h5 class="font-weight-bold">Edit equipments</h5>
                <hr />
            </b-col>
        </b-row>
        <multi-equipment-edit-form :componentData="componentData"/>
    </b-container>
</template>
<script>

import {ModalMixin} from '@/mixins';
import MultiEquipmentEditForm from '@/components/forms/MultiEquipmentEditForm.vue';
export default {
    name: "MultiEquipmentEditModal",
    mixins: [ModalMixin],
    
    props:{
        componentData: Object
    },

    components:{
        MultiEquipmentEditForm
    },
    data(){
        return {

        }
    }
    
}
</script>

<style>
    .equipment-list .dropdown-menu{
        overflow: scroll;
        max-height: 50vh;
    }
    
    .equipment-list .dropdown-menu li+li{
        border-top: 1px solid #ccc;
    } 
    fieldset.form-group legend {
        text-transform: capitalize;
    }
</style>


